import { render, staticRenderFns } from "./InjuriesDictionary.vue?vue&type=template&id=6569274c&lang=pug&"
import script from "./InjuriesDictionary.vue?vue&type=script&lang=js&"
export * from "./InjuriesDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports